module.exports = __webpack_public_path__ + "static/media/beep.f119d745.wav";